import { InboxSubsectionTagRecord } from "libs/schema";
import { UseRecordResult, useRecord } from "./useRecord";

export function useInboxSubsection(inboxSubsectionId?: string | null) {
  const result = useRecord("tag", inboxSubsectionId, { name: "useInboxSubsection" });
  return result as [InboxSubsectionTagRecord | null, UseRecordResult<"tag">[1]];
}
